import { ColDef } from 'ag-grid-community';
import { t } from 'i18next';

import { IJobCustomer } from 'jobs/types';

import { ActionsCell } from './cells';

export const getColumnDefs = (jobId: number, projectId: number): ColDef[] => {
  return [
    {
      colId: 'actions',
      width: 50,
      maxWidth: 50,
      sortable: false,
      resizable: false,
      filter: false,
      enableRowGroup: false,
      suppressHeaderMenuButton: true,
      suppressColumnsToolPanel: true,
      pinned: 'left',
      lockPinned: true,
      suppressMovable: true,
      cellRenderer: ActionsCell,
      cellRendererParams: { jobId, projectId },
    },
    {
      colId: 'foreignContactGroupName',
      headerName: t('labelCustomer'),
      field: 'foreignContactGroupName',
      filter: 'agTextColumnFilter',
      sort: 'asc',
    },
    {
      colId: 'foreignContactName',
      headerName: t('labelCustomerContact'),
      field: 'foreignContactName',
      filter: 'agTextColumnFilter',
    },
    {
      colId: 'foreignContactPhone',
      headerName: t('labelPhone'),
      field: 'foreignContactPhone',
      filter: 'agTextColumnFilter',
    },
    {
      colId: 'foreignCorporateUserEmail',
      headerName: t('labelEmail'),
      field: 'foreignCorporateUserEmail',
      filter: 'agTextColumnFilter',
    },
    {
      colId: 'location',
      headerName: t('labelLocation'),
      valueGetter: ({ data }: { data: IJobCustomer }) => {
        const name = data?.foreignContactSoldToAddressName || '';
        const city = data?.foreignContactSoldToAddressCity || '';

        return city ? `${name}, ${city}` : name;
      },
      filter: 'agTextColumnFilter',
    },
    {
      colId: 'externalCustomerNumber',
      headerName: t('labelCustomerNumber'),
      field: 'externalCustomerNumber',
      filter: 'agTextColumnFilter',
    },
  ];
};
